import styled from 'styled-components';

import { NonStaticContainer } from '@r1-frontend/ui-react/experimental/containers';

import { breakPoints } from '~/src/constants/breakpoints';
import { HEADER_IMG_URL } from '~/src/features/yandex-landing/constants';

import { Container } from '~/src/features/yandex-landing/styled';

export const HeaderBackground = styled.header`
    width: 100%;
    height: 872px;
    padding: 0 90px;
    background-image: url('${HEADER_IMG_URL}sDesktop.jpg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: top center;
    position: relative;
    max-width: 1550px;
    margin: auto;

    @media (min-width: ${breakPoints.sDesktop}) {
        height: 840px;
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 65%, rgba(250, 250, 250, 1) 100%), url('${HEADER_IMG_URL}sDesktop.jpg');

        ${NonStaticContainer} {
            right: 3.5%;
        }
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        height: 877px;
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 55%, rgba(250, 250, 250, 1) 65%), url('${HEADER_IMG_URL}sDesktop.jpg');
        padding: 0 34px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        height: fit-content;
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 45%, rgba(250, 250, 250, 1) 60%), url('${HEADER_IMG_URL}tablet.jpg');
    }

    @media (max-width: ${breakPoints.mobile}) {
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 35%, rgba(250, 250, 250, 1) 45%), url('${HEADER_IMG_URL}tablet.jpg');
        background-size: contain;
        padding: 0 16px;
    }

    @media (max-width: 375px) {
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 35%, rgba(250, 250, 250, 1) 45%), url('${HEADER_IMG_URL}sMobile.jpg');
    }
`;

export const ContainerHead = styled(Container)`
    flex-direction: column;
`;


